import React, { Fragment, useContext, useEffect, useState } from 'react' ;


import "./prescription.css"
import { UserContext } from '../../Context/UserContext.js';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import TimeAgo from '../TimeAgo/TimeAgo.jsx';
import CustomTitle from '../CustomTitle/CustomTitle.jsx';











export default function Prescription() {
   const [prescription , setPrescription] = useState([])
   const{userToken} = useContext(UserContext) ;

   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }

   async function getPrescription () {
      try {
         const { data } = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/api/v1/prescription/getLoggedUserPrescription`, 
            { headers: header }
         );
      
         if (data.message === "success") {
            console.log(data.prescription);
            
            setPrescription(data.prescription);
            // toast.success(`${data.message} - Add Test in Cart`);
         } else {
            toast.error("Unexpected response from the server");
         }
      
      } catch (error) {
         toast.error(error.response?.data?.message || "Something went wrong");
      }
   }

   useEffect(() => {
      getPrescription()
   }, []) ;
   return (
      <Fragment>
         <CustomTitle title="الروشتات" />
         <div className='container Prescription-container'>
            <h1 className='main-header'>عرض كل روشتاتى</h1>
            <div className='under-header'></div>

            {prescription.length > 0 ? 
               prescription.map((ele)=>
                  <div className="bg-body-tertiary rounded-3 p-2 my-3">
                     <div className="image-cart text-center rounded-4 overflow-hidden border border-2 position-relative" >
                           <a href={ele.download_URL} className='download-image' title="حمّل الصورة من هنا">
                              <i className="fa-solid fa-file-arrow-down main-color fs-4"></i>
                           </a>
                           <img src={ele.image} className="w-100" alt="Prescription"/>
                     </div>
                     <div className="mt-4 bg-body-secondary p-4 rounded-3"  >
                        <div className='row text-center mb-2 '>
                           <div className="col-md-6">
                              <p className='mb-1'>Created At : {ele.createdAt.slice(0 , 10)}</p>
                              <div className=''><TimeAgo createdAt={ele.updatedAt}/></div>
                           </div>
                           <div className="col-md-6">
                              <p className='mb-1'>Phone Number: {ele.phone}</p>
                           </div>
                           <div className="col-md-6">
                              <p className='mb-1'>The admin saw  ? {ele.is_seen? <i class="fa-solid fa-eye text-success"></i> : <i class="fa-solid fa-eye-slash text-danger"></i>}</p>
                           </div>
                        </div>
                        <p className='text-center'>{ele.message}</p>
                     </div>
                  </div> 
               )
               : ""}

               <div className='text-center'>
                  <Link to="/SendPrescription" className='btn btn-warning btn-sm w-50' >
                     <i className="fa-regular fa-image me-2"></i>
                     أرسال روشتة أخرى
                  </Link>
               </div>

         </div>
      </Fragment>
   )
}
